/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Endpoint } from '../index';
import { z, ZodTypes } from '../zod';

const Params = z.strictObject({ planId: ZodTypes.Id });

export const AdminPlanStorageDelete = {
  id: 'admin-plan-storage.delete',
  tag: 'Admin',
  summary: 'Delete admin storage plan',
  description: 'Delete a storage plan',
  method: 'delete',
  flags: { isAuthorized: true, isSuperuser: true },
  route: (params: z.infer<typeof Params>) => `/administration/plan/storage/${params.planId}`,
  request: {
    params: Params,
  },
  response: {
    200: {
      description: 'successful',
      content: {
        'application/json': {
          schema: z.string().optional(),
        },
      },
    },
  },
} as const satisfies Endpoint;
